<template>
  <div class="login-page">

    <!-- Redirect spinner overlay -->
    <div class="redirect-overlay" v-if="forgotPasswordSpinner">
      <fa :icon="['fas', 'spinner']" size="2x" class="fa-spin mb-2" />
      <span>Redirecting to Login...</span>
    </div>

    <!-- Left: Brand Panel (matches Login) -->
    <div class="brand-panel">

      <!-- Road-network map background -->
      <img class="brand-bg-map" src="../../assets/roadNetworkMap.svg" alt="" aria-hidden="true" />
      <div class="brand-veil" aria-hidden="true"></div>

      <!-- Coordinate readout -->
      <div class="brand-coords">42.4240&deg; N &middot; 83.4250&deg; W</div>

      <div class="brand-content">
        <p class="brand-tagline">Map Management Platform</p>
        <ul class="brand-features">
          <li>
            <span class="brand-feature-icon"><fa :icon="['fas', 'layer-group']" /></span>
            HD maps
          </li>
          <li>
            <span class="brand-feature-icon"><fa :icon="['fas', 'globe-americas']" /></span>
            Global Geospatial Data
          </li>
          <li>
            <span class="brand-feature-icon"><fa :icon="['fas', 'eye']" /></span>
            Precision
          </li>
        </ul>
      </div>
      <div class="brand-footer">
        <a href="https://dmp-maps.com/legal/" class="brand-legal" target="_blank">
          © {{ new Date().getFullYear() }} Dynamic Map Platform North America, Inc.
        </a>
      </div>
    </div>

    <!-- Right: Form Panel -->
    <div class="form-panel">
       <div class="form-stack">
        <a href="https://www.ushrauto.com/" target="_blank" class="form-logo-link">
          <img src="../../assets/dmpLogin.png" class="form-logo" alt="Dynamic Map Platform" />
        </a>
      <div class="form-card">

        <div class="form-header">
          <h2 class="form-title">Reset Password</h2>
          <p class="form-subtitle">
            {{ otpSent
              ? 'Enter the 6-digit code sent to your email.'
              : 'Enter your registered email to receive a verification code.' }}
          </p>
        </div>

        <!-- Step 1: Email -->
        <div v-if="showemailbox" class="field-group">
          <label class="field-label">Email</label>
          <div class="input-wrap">
            <!-- <fa :icon="['fas', 'envelope']" class="input-icon" /> -->
            <b-form-input
              type="email"
              name="email"
              v-model="email"
              placeholder="you@example.com"
              class="login-input"
            />
          </div>
          <button class="login-btn mt-4" @click="sendOneTimeVerificationCode()">
            Send Code
            <fa :icon="['fas', 'paper-plane']" class="ms-2" />
          </button>
        </div>

        <!-- Step 2: OTP -->
        <div v-if="otpSent" class="field-group">
          <label class="field-label">Verification Code</label>
          <div class="otp-wrap" @click="focusInput">
            <b-form-input
              v-model="onetimecode"
              type="number"
              class="invisible-input"
              maxlength="6"
              autocomplete="off"
              :disabled="!otpSent"
            />
            <div class="otp-display">
              <span v-for="i in 6" :key="i" class="otp-box">
                {{ onetimecode[i - 1] || '' }}
              </span>
            </div>
          </div>
          <button class="login-btn mt-1" @click="verifyOneTimeCode()">
            Verify Code
            <fa :icon="['fas', 'check']" class="ms-2" />
          </button>
        </div>

        <!-- Back to Login -->
        <div class="back-row">
          <span class="back-link" @click="backToLogin()">
            <fa :icon="['fas', 'arrow-left']" class="me-1" />
            Back to Login
          </span>
        </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
// import Forgot_Password_recovery_email from '!!raw-loader!../../../src/emails/Forgot_Password_recovery.html'
import Forgot_Password_recovery from '!!raw-loader!./../../emails/Forgot_Password_recovery.html'
import Forgot_Password_OTP_email from '!!raw-loader!../../../src/emails/Forgot_Password_OTP_Verification.html'
import { generateSecureString } from '../../utils/utils'

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      newPassword: null,
      otpSent: false,
      onetimecode: '',
      otpVerified: false,
      forgotPasswordSpinner: false,
      showemailbox:true
    }
  },
  methods: {
    ...mapActions(['updateGlobalRole', 'updateGlobalAllowedUserModules']),
    focusInput() {
      // Focus the invisible input when overlay is clicked
      this.$el.querySelector('.invisible-input').focus()
    },
    isValidEmail() {
      const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return pattern.test(this.email)
    },
    validateEmail() {
      if (this.email == null || this.email.length == 0) {
        this.feedback = 'Please provide email.'
      } else if (!this.isValidEmail()) {
        this.feedback = 'Please provide a valid email.'
      } else {
        return true
      }

      return false
    },
    forgotPassword() {
      if (!this.validateEmail()) {
        this.showPassWordResetFeedback('danger')
      } else {
        try {
          var self = this
          this.newPassword = generateSecureString(8)
          axios
            .get(process.env.API_LOCATION + '/api/users/forgotPassword', {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              params: {
                email: this.email.toLowerCase().trim(),
                newPassword: this.newPassword,
                id: 0
              }
            })
            .then(response => {
              if (response.data) {
                const content = response.data
                if (content.errors) {
                  this.feedback = content.errors[0].msg
                  this.showPassWordResetFeedback('danger')
                } else {
                  this.forgotPasswordSpinner = true
                  this.sendRecoveryEmail(content)
                }
              }
            })
            .catch(function (error) {
              self.feedback = error.response.data.errors[0].msg
              this.showPassWordResetFeedback('danger')
            })
        } catch (err) {
          console.log('forgotPassword functionality ran into an error : ', err)
        }
      }
    },
    showPassWordResetFeedback(type) {
      this.$bvToast.toast(this.feedback, {
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        title: 'Password Reset',
        toaster: 'b-toaster-top-center'
      })
    },    
    backToLogin() {
      this.$router.push({ name: 'Login' })
    },
    sendRecoveryEmail(content) {
      const fromEmail = 'mmp-info@dmp-maps.com'
      const toEmail = [this.email.toLowerCase().trim()]
      const emailSubject = 'MMP password recovery'
      const emailBody = Forgot_Password_recovery
                        .replace('{{Name}}', content.name)
                        .replace('{{newPassword}}', this.newPassword)      
      axios
        .get(process.env.API_LOCATION + '/api/email/sendemailWithoutToken', {
          method: 'get',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          params: {
            fromEmail: fromEmail,
            toEmail: toEmail,
            emailSubject: emailSubject,
            emailBody: emailBody
          }
        }).then(response => {
          const content = response.data
          if (content.errors) {
            console.log('sendEmail API Call Error')
          } else {
            if (content.some(obj => obj.status !== 'bounced' || obj.status !== 'rejected')) {
              this.feedback = 'An email with a new password has been sent to your registered email please check your inbox'
              this.showPassWordResetFeedback('success')
               
              setTimeout(() => {  
                this.$router.push({ name: 'Login' })                                 
                }, 3000);            

            } else {
              this.feedback = 'There was a server error while sending a new password to your email, please try again later'
              this.showPassWordResetFeedback('danger')
            }
          }
        })
        .catch(function (error) {
          console.log(error)
          self.feedback = error.response.data.errors[0].msg
          self.showFeedback()
        })
    },
    sendOneTimeVerificationCode() {
      if (this.email && this.email != null && this.email.length > 0) {
        if (!this.validateEmail()) {
          this.showPassWordResetFeedback('danger')
          return;
        }
        const fromEmail = 'mmp-info@dmp-maps.com'
        const toEmail = [this.email.toLowerCase().trim()]
        const emailSubject = 'MMP password recovery verification OTP'
        const emailBody = Forgot_Password_OTP_email
        this.showemailbox=false
        axios
          .get(process.env.API_LOCATION + '/api/users/sendOtpForgotPassword', {
            method: 'get',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            params: {
              fromEmail: fromEmail,
              toEmail: toEmail,
              emailSubject: emailSubject,
              emailBody: emailBody
            }
          })
          .then(response => {
            if (response.data.status == 400) {
              this.feedback = response.data.message
              this.showPassWordResetFeedback('danger')
              this.otpSent = true
            } else {
              const content = response.data
              if (content.errors) {
                console.log('sendOneTimeVerificationCode API Call Error => ' + content.errors)
                this.feedback = content.errors
                this.showPassWordResetFeedback('danger')
                this.otpSent = false
              } else {
                if (content.some(obj => obj.status !== 'bounced' || obj.status !== 'rejected')) {
                  this.feedback = 'An email with a One time code has been sent to your registered email please check your inbox'
                  this.showPassWordResetFeedback('success')
                  this.otpSent = true
                } else {
                  this.feedback = 'There was a server error while sending a one time code to your email, please try again later'
                  this.showPassWordResetFeedback('danger')
                  this.otpSent = false
                }
              }
            }
          })
          .catch(function (error) {
            console.log(" sendOneTimeVerificationCode error => " + error)
            console.log(error)
            this.feedback = error.response.data.errors[0].msg
            this.showPassWordResetFeedback('danger')
          })
      }
      else {
        this.feedback = 'Please enter a valid email address'
        this.showPassWordResetFeedback('danger')
      }
    },
    verifyOneTimeCode(){
      axios
        .get(process.env.API_LOCATION + '/api/users/verifyOneTimeCode', {
          method: 'get',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          params: {
            email: this.email.toLowerCase().trim(),
            onetimecode: this.onetimecode,
          }
        })
        .then(response => {
          const content = response
          if (content.errors) {
            this.feedback = content.errors
            this.showPassWordResetFeedback('danger')
            this.otpVerified = false
          } else {
            if (content.status == '200' && content.data == 'Success' ) {
              this.feedback = 'The one-time code you entered is correct. Please Click on Send New Password button to receive a new password on your Email.'
              this.showPassWordResetFeedback('success')
              this.otpVerified = true      
              this.forgotPassword()        
            } else if(content.status == '204' ){
              this.feedback = 'The one-time code you entered is incorrect. Please check the code and try again.'
              this.showPassWordResetFeedback('danger')
              this.otpVerified = false
            }
          }
        })
        .catch(function (error) {
          console.log(error)
          this.otpVerified = false
          self.feedback = error.response.data.errors[0].msg
          self.showFeedback()

        })
    }
  }
}
</script>

<style scoped>
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body, html {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  font-family: "Segoe UI", "Roboto", "Open Sans", Arial, sans-serif;
}

/* ── Page Layout ─────────────────────────────── */
.login-page {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

/* ── Left Brand Panel ────────────────────────── */
.brand-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 3rem 2rem;
  background:
    radial-gradient(120% 90% at 15% 0%, rgba(60, 191, 111, 0.18) 0%, rgba(60, 191, 111, 0) 45%),
    radial-gradient(120% 90% at 90% 100%, rgba(41, 171, 226, 0.24) 0%, rgba(41, 171, 226, 0) 55%),
    linear-gradient(160deg, #123f68 0%, #0c2e4e 48%, #071f38 100%);
  position: relative;
  overflow: hidden;
}

/* Full-bleed road-network map */
.brand-bg-map {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.6;
  z-index: 0;
  pointer-events: none;
}

/* Soft veil that concentrates tint behind the content for legibility */
.brand-veil {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: radial-gradient(ellipse 62% 56% at 50% 46%,
    rgba(15, 74, 122, 0.68) 0%,
    rgba(15, 74, 122, 0.20) 55%,
    rgba(15, 74, 122, 0) 100%);
}

/* Coordinate readout chip */
.brand-coords {
  position: absolute;
  top: 1.5rem;
  left: 1.75rem;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-family: 'Courier New', monospace;
  font-size: 0.72rem;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.6);
}

.brand-coords::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3cbf6f;
  box-shadow: 0 0 0 3px rgba(60, 191, 111, 0.25);
}

.brand-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 2.25rem;
  text-align: center;
}

.brand-tagline {
  color: rgba(255, 255, 255, 0.72);
  font-size: 1.2rem;
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
  letter-spacing: 3px;
}

.brand-features {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem 1.4rem;
  margin: 0;
  padding: 0;
}

.brand-features li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  position: relative;
}

/* Hairline dividers between feature labels */
.brand-features li:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -0.75rem;
  height: 12px;
  width: 1px;
  background: rgba(255, 255, 255, 0.18);
}

.brand-feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #5cc0ea;
  font-size: 0.78rem;
}

.brand-image-card {
  width: clamp(220px, 28vw, 340px);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(0, 0, 0, 0.2);
}

.brand-map-image {
  width: 100%;
  display: block;
  object-fit: cover;
  opacity: 0.92;
}

.brand-image-caption {
  padding: 0.5rem 0.85rem;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.7);
  background: rgba(0, 0, 0, 0.25);
  letter-spacing: 0.3px;
}

.brand-footer {
  position: relative;
  z-index: 1;
}

.brand-legal {
  color: rgba(255,255,255,0.5);
  font-size: 0.95rem;
  text-decoration: none;
}

.brand-legal:hover {
  color: rgba(255,255,255,0.8);
  text-decoration: underline;
}

/* ── Right Form Panel ────────────────────────── */
.form-panel {
  width: clamp(500px, 45%, 800px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  padding: 2rem;
}

.form-stack {
  width: 100%;
  max-width: 470px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.form-logo-link {
  display: block;
  width: 100%;
  text-align: center;
  line-height: 0;
}

.form-logo {
  width: clamp(180px, 60%, 240px);
  display: inline-block;
  margin: 0 auto;
}

.form-card {
  width: 100%;
  background: #fff;
  border-radius: 14px;
  padding: 2.5rem 2.25rem;
  box-shadow: 0 4px 32px rgba(6, 60, 109, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-header {
  margin-bottom: 0.25rem;
}

.form-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #063c6d;
  margin-bottom: 0.3rem;
}

.form-subtitle {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
}

/* ── Fields ──────────────────────────────────── */
.field-group {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.field-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #063c6d;
  margin: 0;
}

.input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.login-input {
  padding-left: 0.85rem !important;
  padding-right: 0.85rem !important;
  height: 44px;
  border: 1.5px solid #dee2e6;
  border-radius: 8px !important;
  font-size: 0.95rem;
  color: #212529;
  background: #f8f9fa;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
  width: 100%;
}

.login-input:focus {
  border-color: #4A74A8 !important;
  box-shadow: 0 0 0 3px rgba(74, 116, 168, 0.15) !important;
  background: #fff;
  outline: none;
}

/* ── Login Button ────────────────────────────── */
.login-btn {
  width: 100%;
  height: 46px;
  background: #4A74A8;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: 0 2px 8px rgba(74, 116, 168, 0.35);
  transition: background-color 0.18s ease, box-shadow 0.18s ease, transform 0.1s ease;
  margin-top: 0.25rem;
}

.login-btn:hover {
  background: #316fb1;
  box-shadow: 0 4px 14px rgba(74, 116, 168, 0.45);
  transform: translateY(-1px);
}

.login-btn:active {
  background: #063c6d;
  box-shadow: none;
  transform: translateY(0);
}

/* ── Redirect spinner overlay ────────────────── */
.redirect-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(6, 60, 109, 0.55);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1rem;
  gap: 0.5rem;
  backdrop-filter: blur(2px);
}

/* ── OTP input ───────────────────────────────── */
.otp-wrap {
  position: relative;
  cursor: text;
}

.invisible-input {
  position: absolute;
  inset: 0;
  z-index: 2;
  opacity: 0;
  width: 100%;
  height: 100%;
  caret-color: transparent;
}

.otp-display {
  display: flex;
  gap: 0.5rem;
  padding: 0 0.75rem;
  height: 44px;
  align-items: center;
  background: #f8f9fa;
  border: 1.5px solid #dee2e6;
  border-radius: 8px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.otp-wrap:focus-within .otp-display {
  border-color: #4A74A8;
  box-shadow: 0 0 0 3px rgba(74, 116, 168, 0.15);
  background: #fff;
}

.otp-box {
  flex: 1;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: #063c6d;
  border-bottom: 2px solid #adb5bd;
  min-width: 24px;
  line-height: 1;
  padding-bottom: 2px;
}

.form-stack {
  width: 100%;
  max-width: 470px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}
/* ── Back link ───────────────────────────────── */
.back-row {
  margin-top: 0.25rem;
}

.back-link {
  color: #4A74A8;
  font-size: 0.87rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  transition: color 0.15s ease;
}

.back-link:hover {
  color: #063c6d;
  text-decoration: underline;
}

/* ── Responsive ──────────────────────────────── */
@media (max-width: 700px) {
  .brand-panel {
    display: none;
  }
  .form-panel {
    width: 100vw;
    padding: 1.5rem;
  }
}
</style>
